const buildTargetFields = (context) => {
    if (context.targetType === 'EXISTING_EIKA_SHARE_SAVINGS_ACCOUNT') {
        if (!context.targetAccount) {
            return null;
        }
        return {
            targetType: 'EXISTING_EIKA_SHARE_SAVINGS_ACCOUNT',
            targetAccountNumber: context.targetAccount.accountNumber,
        };
    }
    if (context.targetType === 'NEW_EIKA_SHARE_SAVINGS_ACCOUNT') {
        return {
            targetType: 'NEW_EIKA_SHARE_SAVINGS_ACCOUNT',
            targetAccountName: context.targetAccountName,
        };
    }
    return null;
};
export const buildTransferPayload = (context) => {
    const { bankProvider, email, transferType, targetType, numberOfAccounts, sourceAccountNumber } = context;
    const SPARING_APPLICATION = 'MSS';
    if (!bankProvider || !email || !transferType || !targetType) {
        return null;
    }
    const targetFields = buildTargetFields(context);
    if (!targetFields) {
        return null;
    }
    const baseFields = {
        providerId: bankProvider.id,
        email,
        sparingApplication: SPARING_APPLICATION,
        ...targetFields,
    };
    if (transferType === 'TRANSFER_ALL') {
        if (!numberOfAccounts) {
            return null;
        }
        return { ...baseFields, transferType, numberOfAccounts };
    }
    if (!sourceAccountNumber) {
        return null;
    }
    return { ...baseFields, transferType, sourceAccountNumber };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtdHJhbnNmZXItcGF5bG9hZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9hcHBzL3RyYW5zZmVyLXNoYXJlLXNhdmluZ3MtYWNjb3VudC91dGlscy9idWlsZC10cmFuc2Zlci1wYXlsb2FkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE1BQU0saUJBQWlCLEdBQUcsQ0FDdEIsT0FBb0IsRUFDZ0UsRUFBRTtJQUN0RixJQUFJLE9BQU8sQ0FBQyxVQUFVLEtBQUsscUNBQXFDLEVBQUUsQ0FBQztRQUMvRCxJQUFJLENBQUMsT0FBTyxDQUFDLGFBQWEsRUFBRSxDQUFDO1lBQ3pCLE9BQU8sSUFBSSxDQUFDO1FBQ2hCLENBQUM7UUFFRCxPQUFPO1lBQ0gsVUFBVSxFQUFFLHFDQUFxQztZQUNqRCxtQkFBbUIsRUFBRSxPQUFPLENBQUMsYUFBYSxDQUFDLGFBQWE7U0FDM0QsQ0FBQztJQUNOLENBQUM7SUFFRCxJQUFJLE9BQU8sQ0FBQyxVQUFVLEtBQUssZ0NBQWdDLEVBQUUsQ0FBQztRQUMxRCxPQUFPO1lBQ0gsVUFBVSxFQUFFLGdDQUFnQztZQUM1QyxpQkFBaUIsRUFBRSxPQUFPLENBQUMsaUJBQWlCO1NBQy9DLENBQUM7SUFDTixDQUFDO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDaEIsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxPQUFvQixFQUFzQixFQUFFO0lBQzdFLE1BQU0sRUFBRSxZQUFZLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBRSxVQUFVLEVBQUUsZ0JBQWdCLEVBQUUsbUJBQW1CLEVBQUUsR0FBRyxPQUFPLENBQUM7SUFDekcsTUFBTSxtQkFBbUIsR0FBdUIsS0FBSyxDQUFDO0lBRXRELElBQUksQ0FBQyxZQUFZLElBQUksQ0FBQyxLQUFLLElBQUksQ0FBQyxZQUFZLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQztRQUMxRCxPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0lBRUQsTUFBTSxZQUFZLEdBQUcsaUJBQWlCLENBQUMsT0FBTyxDQUFDLENBQUM7SUFFaEQsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7SUFFRCxNQUFNLFVBQVUsR0FBRztRQUNmLFVBQVUsRUFBRSxZQUFZLENBQUMsRUFBRTtRQUMzQixLQUFLO1FBQ0wsa0JBQWtCLEVBQUUsbUJBQW1CO1FBQ3ZDLEdBQUcsWUFBWTtLQUNsQixDQUFDO0lBRUYsSUFBSSxZQUFZLEtBQUssY0FBYyxFQUFFLENBQUM7UUFDbEMsSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7WUFDcEIsT0FBTyxJQUFJLENBQUM7UUFDaEIsQ0FBQztRQUVELE9BQU8sRUFBRSxHQUFHLFVBQVUsRUFBRSxZQUFZLEVBQUUsZ0JBQWdCLEVBQUUsQ0FBQztJQUM3RCxDQUFDO0lBRUQsSUFBSSxDQUFDLG1CQUFtQixFQUFFLENBQUM7UUFDdkIsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUVELE9BQU8sRUFBRSxHQUFHLFVBQVUsRUFBRSxZQUFZLEVBQUUsbUJBQW1CLEVBQUUsQ0FBQztBQUNoRSxDQUFDLENBQUMifQ==